import { createJSONStorage } from 'jotai/utils';
import type { SyncStorage } from 'jotai/vanilla/utils/atomWithStorage';

export const sessionStorageHelper = createJSONStorage(() =>
  //@ts-expect-error sessionStorage is not defined in node
  typeof window !== 'undefined' ? window.sessionStorage : undefined,
) as SyncStorage<Record<string, any>>;
